import { contactMailto } from "@/lib/contact";

/**
 * Renders a server message, turning "Contact us" into a mailto link to
 * hello@pagepledge.com with `subject` prefilled. Messages stay plain text
 * on the server; the subject travels alongside them (flash[:contact_subject]
 * or an import error's contact_subject). Without a subject, renders as-is.
 */
export default function ContactText({ text, subject }) {
  if (!subject || !/contact us/i.test(text)) return text;

  return text.split(/(contact us)/i).map((part, i) =>
    /^contact us$/i.test(part) ? (
      <a key={i} href={contactMailto(subject)} className="font-medium underline underline-offset-2">
        {part}
      </a>
    ) : (
      part
    )
  );
}
